import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Flex,
  Text,
  Stack,
  Input,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import { FaEllipsisV } from "react-icons/fa";
import Modal_lib_student_sidebar_table from "./Modal_lib_student_sidebar_table";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Library_Book_Return = () => {
  const [borrowedBooks, setBorrowedBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null); // For selected book data to show in modal
  const [data, setData] = useState(false);

  const [sortOption, setSortOption] = useState("title"); // Define sortOption state
  const [currentPage, setCurrentPage] = useState(1); // Define currentPage state
  const [rowsPerPage, setRowsPerPage] = useState(10); // Define rowsPerPage state

  const schoolId = sessionStorage.getItem("school_id"); // Replace with actual school ID
  const studentId = sessionStorage.getItem("student_id"); // Replace with actual student ID

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/library/category/list_category.php?school_id=${schoolId}`
        );

        if (response.data.success) {
          setCategories(response.data.data);
        } else {
          setError(response.data.message || "Failed to fetch categories");
        }
      } catch (err) {
        setError(err.message || "An error occurred while fetching categories");
      }
    };

    if (schoolId) {
      fetchCategories();
    }
  }, [schoolId]);

  const filteredBooks = borrowedBooks.filter((book) => {
    const matchesCategory =
      !selectedCategory || book.category === selectedCategory;
    const matchesSearch =
      !searchQuery ||
      book.title.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  useEffect(() => {
    const fetchMemberIdAndBooks = async () => {
      try {
        const schoolId = sessionStorage.getItem("school_id");
        const studentId = sessionStorage.getItem("student_id");

        if (!schoolId || !studentId) {
          setError("School ID or Student ID is missing.");
          setLoading(false);
          return;
        }

        // Fetch member_id from s_membership_details.php
        const memberResponse = await axios.get(
          `${BASE_URL}/student/library/s_membership_details.php?school_id=${schoolId}&student_id=${studentId}`
        );

        if (memberResponse.data.success) {
          const memberId = memberResponse.data.data.member_id;

          // Fetch borrowed books using member_id
          const bookResponse = await axios.get(
            `${BASE_URL}/admin/library/issues/borrowed_books.php?school_id=${schoolId}&member_id=${memberId}`
          );
          console.log("book res", bookResponse);

          if (bookResponse.data.success && bookResponse.data.data.length > 0) {
            setBorrowedBooks(bookResponse.data.data);
          } else {
            setError("No book taken from library.");
          }
        } else {
          setError("Membership details not found.");
        }
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setError("No book taken from library.");
        } else {
          setError("An error occurred while fetching borrowed books.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMemberIdAndBooks();
  }, []);

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
    const sortedBooks = [...borrowedBooks];
    if (e.target.value === "title") {
      sortedBooks.sort((a, b) => a.title.localeCompare(b.title));
    } else if (e.target.value === "name") {
      sortedBooks.sort((a, b) => a.name.localeCompare(b.name));
    }
    setBorrowedBooks(sortedBooks);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredBooks.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(filteredBooks.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const handleOpenModal = (book) => {
    setSelectedBook(book);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBook(null);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  // if (error) {
  //   return <div>Error: {error}</div>;
  // }

  return (
    <Box overflowX="auto" bg="#FBFBFD">
      <div className="teacher-list-container">
        <div className="header">
          <h1 fontSize="20px">Books</h1>
          <div className="action-buttons"></div>
        </div>

        <div className="breadcrumb">
          <Text as="span">Dashboard</Text> / <Text as="span">Library</Text>
        </div>

        <Box mt={5}>
          <Flex
            direction={{ base: "column", md: "row" }}
            justify={{ base: "center", md: "space-between" }}
            align="center"
            mb={1}
            p={3}
            className="sb"
            wrap="wrap"
            gap={4} // Add gap for spacing between elements in wrap mode
          >
            <Stack
              direction={{ base: "column", md: "row" }}
              spacing={{ base: 2, md: 4 }}
              align="center"
              mb={{ base: 2, md: 0 }}
            >
              <Flex align="center">
                <Text mr={2} fontSize={{ base: "sm", md: "md" }}>
                  Rows Per Page
                </Text>
                <Select
                  width={{ base: "80px", md: "100px" }}
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(Number(e.target.value))}
                  borderColor="#E9EDF4"
                  fontSize={{ base: "sm", md: "md" }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </Select>
              </Flex>
            </Stack>

            <Flex
              align="center"
              justify={{ base: "center", md: "flex-end" }}
              direction={{ base: "column", md: "row" }}
              spacing={4}
              wrap="wrap"
              gap={{ base: 2, md: 4 }}
            >
              <Input
                placeholder="Search for books"
                value={searchQuery}
                onChange={handleSearchChange}
                width={{ base: "100%", md: "200px" }}
                borderColor="#E9EDF4"
                mb={{ base: 2, md: 0 }}
                fontSize={{ base: "sm", md: "md" }}
              />
              <Select
                value={selectedCategory}
                onChange={handleCategoryChange}
                borderColor="#E9EDF4"
                width={{ base: "100%", md: "200px" }}
                fontSize={{ base: "sm", md: "md" }}
              >
                <option value="">All Categories</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </Select>
            </Flex>
          </Flex>

          <Box overflowX="auto" maxWidth="100%">
            <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
              <Thead>
                <Tr>
                  <Th>Book Title</Th>
                  {/* <Th>Student Name</Th> */}
                  <Th>Due Date</Th>
                  <Th>Fine Date</Th>
                  <Th>Fine Amount</Th>
                  <Th>Payment Mode</Th>
                  <Th>Paid</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentData.map((book) => (
                  <Tr key={book.id}>
                    <Td>{book.title}</Td>
                    {/* <Td>{book.name}</Td> */}
                    <Td>{book.due_date}</Td>
                    <Td>
                      {book.fine_date
                        ? new Date(book.fine_date).toLocaleDateString()
                        : "N/A"}
                    </Td>
                    <Td>{book.fine_amount ? `$${book.fine_amount}` : "N/A"}</Td>
                    <Td>{book.payment_mode || "N/A"}</Td>
                    <Td>{book.paid ? "Yes" : "No"}</Td>
                    <Td>
                      {/* Add the condition to show the Pay button */}
                      {book.status === "Returned" &&
                        book.fine_amount !== null &&
                        book.paid === 0 && (
                          <Button
                            colorScheme="blue"
                            size="xs"
                            alignSelf="flex-end"
                            mt={4}
                            onClick={() => {
                              handleOpenModal();
                              setData(book);
                            }}
                          >
                            Pay
                          </Button>
                        )}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
          {isModalOpen && (
            <Modal_lib_student_sidebar_table
              isOpen={isModalOpen}
              onClose={handleCloseModal}
              last={data ? data.due_date : ""}
              memberId={data.member_id}
              fineeId={data.fine_id}
              studentId={data.student_id}
              totalAmount={data.fine_amount}
              StudentLedgerId={data.student_ledger_id}
            />
          )}
          <Flex justify="end" borderTopWidth="1px" className="sb2" p={3}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
              mr={2}
            >
              Prev
            </Button>
            <Stack direction="row" spacing={2} mx={2}>
              {currentPage > 1 && (
                <>
                  <Button onClick={() => handlePageChange(1)}>1</Button>
                  {currentPage > 2 && <Text>...</Text>}
                </>
              )}
              <Button backgroundColor="teal" color="white">
                {currentPage}
              </Button>
              {currentPage < totalPages - 1 && (
                <>
                  <Text>...</Text>
                  <Button onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                  </Button>
                </>
              )}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
              ml={2}
            >
              Next
            </Button>
          </Flex>
        </Box>
      </div>
    </Box>
  );
};

export default Library_Book_Return;
